import React from "react";

// In the browser, direct calls to the API origin can be blocked by CORS during local dev.
// Vite is configured to proxy `/api/*` -> `VITE_API_ENDPOINT` (or `VITE_API_ORIGIN`).
// Use that proxy in dev to avoid CORS, but keep the real endpoint for production builds.
const api_endpoint = import.meta.env.VITE_API_ENDPOINT;

export { api_endpoint };
